<template>
  <div class="inner">
    <article id="detailInner">
      <h1>ページが見つかりませんでした。</h1>
    </article>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {}
  },
  beforeRouteEnter: function (to, from, next) {
    next()
  }
}
</script>

<style scoped>
  h1 {
    text-align: center;
    font-size:150%;
    font-weight:bold;
    margin: 200px 0;
  }
</style>
